import { get } from '@web3/base-utils';
import { SolConfig, AirdropActivities, AirdropReward } from '@/types/bbsol';
import { baseApiUrl } from '@/config/api';
import { ChartType, bbsolChartData } from '@/types/chart';

export const getbbSolConfig = async () => {
  return get<SolConfig>(`${baseApiUrl}/v3/lst/bbsol/config`);
};

export const getbbSolRatio = async (poolId: string, span: ChartType) => {
  return get<bbsolChartData>(`${baseApiUrl}/v3/lst/bbsol/ratio`, {
    poolId,
    span: Number(span),
  });
};

/**
 * 获取 bbSOL 的空投活动数据
 * @param activityCode 活动代码
 * @returns
 */
export const getBbSolAirdropActivity = async (activityCode: string) => {
  return get<AirdropActivities>(`${baseApiUrl}/v3/lst/airdrop/activity`, {
    activityCode,
  });
};

/**
 * 获取指定钱包空投奖励列表
 * @param walletAddress 当前登录的钱包地址
 * @param activityCode 活动代码
 * @returns
 */
export const getBbSolUserAirdropRewards = async (
  walletAddress: string,
  activityCode: string
) => {
  return get<AirdropReward>(`${baseApiUrl}/v3/lst/airdrop/rewardList`, {
    walletAddress,
    activityCode,
  });
};

/**
 * 通过空投活动的开始结束时间计算状态
 */
export function getAirdropActivityStatus(
  startTime: number,
  endTime: number,
  currentTime: number
) {
  const nowTime = currentTime || new Date().getTime();
  // 开始和结束时间都为空返回 unknown
  if (!startTime && !endTime) {
    return 'unknown';
  }
  //
  if (nowTime < startTime) {
    return 'upcoming';
  }
  if (startTime < nowTime && nowTime < endTime) {
    return 'ongoing';
  }
  if (nowTime > endTime) {
    return 'ended';
  }
  return 'unknown';
}
